'use strict';

import Component from 'generic.basecomponent';
import menuManager from 'menu-manager';

export default class NavTop extends Component {
    constructor(el) {
        super(el);
        this.init();
    }

    init() {
        this.menuId = 'navTop';
        this.items = [...this.container.querySelectorAll(".js-nav-top-item")];
        if(!this.container.classList.contains('js-nav-top--mobile')) {
            this.items.forEach(element => {
                element.addEventListener("mouseenter", this.hover.bind(this));
                element.addEventListener("mouseleave", this.blur.bind(this));
            });

            menuManager.init(this.menuId, {
                default: {
                    open: this.open.bind(this),
                    close: this.close.bind(this),
                    level: 0,
                    isBlocking: false
                },
                mobile: {
                    isEnabled: false
                }
            });
        } else {
            this.mobileOpened = false;
            this.items.forEach(element => {
                element.addEventListener("click", this.toggleMobileInstance.bind(this));
            });
        }
    }

    hover() {
        menuManager.open(this.menuId);
    }

    blur() {
        menuManager.close(this.menuId);
    }

    toggleMobileInstance(e) {
        if(!this.mobileOpened) {
            e.preventDefault();
        }
        this.container.classList.toggle("is-opened");
        this.mobileOpened = !this.mobileOpened;
    }

    open() {
        this.container.classList.add("is-hover");
    }

    close() {
        this.container.classList.remove("is-hover");
    }
}


NavTop.id = 0;



// WEBPACK FOOTER //
// ./app/components/nav-top/js/generic.navtop.js